import React from 'react';
import { motion } from 'framer-motion';
import { Download } from 'lucide-react';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('offer-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-[#FDFAF5] pt-20 pb-16 px-4 overflow-hidden" data-id="element-90">
      <div className="max-w-[720px] mx-auto text-center" data-id="element-91">
        <FadeIn data-id="element-92">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-[#1A1A1A] leading-tight mb-6 tracking-tight" data-id="element-93">
            El Protocolo Anti-Inflamatorio 72h:{' '}
            <span className="text-[#2D5A27]" data-id="element-94">
              Recupera tu Vientre Plano y tu Energía en solo 3 Días
            </span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-95">
          <p className="text-lg md:text-xl text-[#5A5A5A] mb-10 leading-relaxed" data-id="element-96">
            La guía paso a paso para desactivar los disparadores biológicos que
            te hinchan, sin contar calorías ni pasar hambre.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-97">
          <motion.div animate={{
          y: [0, -10, 0]
        }} transition={{
          repeat: Infinity,
          duration: 4,
          ease: 'easeInOut'
        }} className="relative mx-auto w-full max-w-[500px] mb-10" data-id="element-98">
            <div className="absolute inset-0 bg-[#4A7C42] opacity-10 blur-2xl rounded-full" data-id="element-99"></div>
            <img src="https://cdn.magicpatterns.com/uploads/mprfJ8hRi3YLRc3x4uoTpv/thumb.png" alt="Protocolo Anti-Inflamatorio 72h en tablet" className="relative z-10 w-full h-auto rounded-2xl shadow-2xl border border-[#E8F5E2]" data-id="element-100" />
          </motion.div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-101">
          <div className="flex flex-col items-center" data-id="element-102">
            <Button onClick={scrollToOffer} icon={<Download className="w-6 h-6" data-id="element-104" />} data-id="element-103">
              SÍ, QUIERO DESINFLAMARME AHORA
            </Button>
            <p className="mt-4 text-sm text-[#5A5A5A] font-medium flex items-center gap-2" data-id="element-105">
              <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-106"></span>
              Descarga instantánea ·{' '}
              <span className="line-through text-gray-400" data-id="element-107">$27</span>{' '}
              <span className="text-[#2D5A27] font-bold" data-id="element-108">Solo $6.99 USD</span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}